import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Switch, Typography, Table, Tag } from 'antd';
import Stack from 'components/common/Stack';
import { getClientById } from 'api/clientApi';
import { Link } from 'react-router-dom';
import formatDate from 'utils/formatDate';
import Toolbar from 'components/common/Toolbar';
import ClientProjectTimeline from './ClientProjectTimeline';
import CardCollapse from 'components/common/collapse/CardCollapse';
import ClientProjectFilters from './ClientProjectFilters';
import { trackComponent } from 'telemetry/AppInsights';

const ClientDetailPage = props => {
  const [client, setClient] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showProjectTimeline, setShowProjectTimeline] = useState(false);

  const clientId = props.match.params.clientId;
  let activePanels = ['projects'];

  useEffect(() => {
    getClientById(clientId).then(client => {
      setClient(client);
      setFilteredProjects(client.projects);
    });
  }, []);

  const columns = [
    {
      title: 'Project',
      key: 'project',
      render: record => <Link to={`/projects/${record.id}`}>{record.name}</Link>
    },
    {
      title: 'Practice',
      dataIndex: 'practice',
      key: 'practice',
      sorter: (a, b) => (a.practice < b.practice ? -1 : 1)
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: formatDate,
      sorter: (a, b) => (a.startDate < b.startDate ? -1 : 1)
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: formatDate,
      defaultSortOrder: 'descend',
      sorter: (a, b) => (a.endDate < b.endDate ? -1 : 1)
    },
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      align: 'right',
      render: record => <Tag color={record ? 'green' : 'red'}>{record ? 'Active' : 'Inactive'}</Tag>,
      sorter: (a, b) => (a.active < b.active ? -1 : 1)
    }
  ];

  const onChangeShowProjectTimeline = (checked, e) => {
    e.stopPropagation();
    setShowProjectTimeline(checked);
  };

  return (
    <Stack>
      <Typography.Title level={1} style={{ marginBottom: '0' }}>
        {client && client.name}
      </Typography.Title>
      <Typography.Title level={3} type="secondary" style={{ marginTop: '0' }}>
        {client.location}&nbsp;·&nbsp;
        {client.projects && client.projects.length} Projects&nbsp;·&nbsp;
        {client.projects && formatDate(client.projects[client.projects.length - 1].startDate)}-
        {client.projects && formatDate(client.projects[0].endDate)}
      </Typography.Title>
      <Collapse bordered={false} defaultActiveKey={activePanels} style={{ width: '100%' }}>
        {client.projects && client.projects.length && (
          <CardCollapse.Panel
            key="projects"
            header={
              <>
                <Icon type="project" /> Projects
              </>
            }
            extra={
              <>
                <Switch
                  checkedChildren="Table"
                  unCheckedChildren="Timeline"
                  defaultChecked={showProjectTimeline}
                  onChange={onChangeShowProjectTimeline}
                />
                &nbsp;
                <Tag>
                  {client.projects && client.projects.length} Project
                  {client.projects && client.projects.length === 1 ? '' : 's'}
                </Tag>
              </>
            }
          >
            <Toolbar style={{ width: '100%' }}>
              <ClientProjectFilters onSearch={setFilteredProjects} projects={client.projects} />
              <div>
                <span style={{ margin: '0 10px' }}>
                  Showing {filteredProjects.length} of {client.projects && client.projects.length} Projects
                </span>
              </div>
            </Toolbar>
            {showProjectTimeline && filteredProjects.length && <ClientProjectTimeline projects={filteredProjects} />}
            {!showProjectTimeline && (
              <Table
                pagination={{ position: 'none', pageSize: client.projects && client.projects.length }}
                style={{ width: '100%' }}
                rowKey={record => record.id}
                columns={columns}
                dataSource={filteredProjects}
              />
            )}
          </CardCollapse.Panel>
        )}
      </Collapse>
    </Stack>
  );
};

export default trackComponent(ClientDetailPage, 'Client Detail Page');
